import { Link } from 'react-router-dom';
import { Clock, DollarSign, GraduationCap, Laptop } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CourseCard({ course }) {
  const formatPrice = (price) => {
    return `$${(price / 1000).toFixed(1)}k`;
  };

  return (
    <article className="border border-border/40 bg-card shadow-sm hover:shadow-md transition-all rounded-sm overflow-hidden" data-testid={`course-card-${course.course_id}`}>
      <div className="relative overflow-hidden aspect-[16/10]">
        <img
          src={course.image}
          alt={course.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 left-3 bg-primary text-primary-foreground px-2 py-1 text-xs font-semibold uppercase">
          {course.course_type}
        </div>
      </div>
      <div className="p-4">
        <div className="text-sm text-accent font-semibold mb-2">{course.university}</div>
        <h3 className="text-lg font-playfair font-bold text-foreground mb-2 line-clamp-2">{course.title}</h3>
        <p className="text-sm text-muted-foreground leading-relaxed mb-3 line-clamp-2">
          {course.description}
        </p>

        <div className="grid grid-cols-2 gap-2 mb-3 text-xs">
          <div className="flex items-center gap-1 text-muted-foreground">
            <GraduationCap size={14} />
            <span>{course.degree_level}</span>
          </div>
          <div className="flex items-center gap-1 text-muted-foreground">
            <Clock size={14} />
            <span>{course.duration}</span>
          </div>
        </div>

        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-1 text-lg font-bold text-foreground">
            <DollarSign size={18} />
            <span>{formatPrice(course.price)}</span>
          </div>
          <span className="text-xs bg-secondary text-secondary-foreground px-2 py-1 rounded-sm">
            {course.category}
          </span>
        </div>

        <Button className="w-full rounded-sm" data-testid={`enroll-${course.course_id}`}>
          Enroll Now
        </Button>
      </div>
    </article>
  );
}